module.exports = __webpack_public_path__ + "static/media/SO2320F2.2740c8b5.png";